export const isPermitted = (requirements: string[], permissionMap: string[]) => {
  return !!permissionMap.find(permission => requirements.find(requirement => requirement === permission));
};
